import { Component, Input } from '@angular/core';

@Component({
  selector: 'idp-step',
  templateUrl: './step.component.html',
  styleUrls: ['./step.component.scss']
})
export class StepComponent {
  @Input() label = '';
  @Input() secondary = false;
}
